import { useState, useMemo } from "react";

/**
 * @typedef {import("immutable").Map} ImmutableMap
 * @typedef {"desktop"|"mobile"} Layout
 */

/**
 * Creates a position map and emits when it's values make a meaningful change
 * @param {ImmutableMap} initialElement 
 * @param {Layout} initialLayout 
 * @param {(element: ImmutableMap, layout) => ImmutableMap} formatter 
 * @returns 
 */
const usePosition = (initialElement, initialLayout, formatter) => {
  const [position, setPosition] = useState(formatter(initialElement, initialLayout));

  const updatePosition = (element, layout) => {
    const result = formatter(element, layout);
    if (!result.equals(position)) {
      setPosition(result);
    }
  };

  return useMemo(() => [position, updatePosition], [position]);
};

export default usePosition;
